// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610072302/js/" + chunkId + "." + {"44":"ccf1dc30","225":"b40d870a","481":"9aa4fec8","486":"ded002a9","770":"c798bd03"}[chunkId] + ".0.3146126260368697.chunk.js";
};